import { render, staticRenderFns } from "./siteRank.vue?vue&type=template&id=067a2290&scoped=true&"
import script from "./siteRank.vue?vue&type=script&lang=js&"
export * from "./siteRank.vue?vue&type=script&lang=js&"
import style0 from "./siteRank.vue?vue&type=style&index=0&id=067a2290&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a2290",
  null
  
)

export default component.exports